'use client';

/**
 * Spaces view (rail-redesign, wireframe-matched): a single tree of ALL the
 * user's workspaces, with the current one auto-expanded to its items. There is
 * no dropdown switcher — switching is just opening another workspace row. Per
 * workspace actions (open, rename, share, settings, duplicate, delete) live on
 * each row's hover ⋯ menu; creating a workspace is the panel header's "+".
 */

import { WorkspacesTab } from './workspaces-tab';

export function SpacesView() {
  return <WorkspacesTab hideCreate />;
}
